/*
 * Bouton "Acheter maintenant" de la fiche produit.
 *
 * Sans ce script, le bouton est un simple submit du formulaire produit :
 * il est intercepte par <product-form-component>, la variante part dans le
 * panier et le tiroir s'ouvre. Ce n'est pas ce qu'un acheteur attend d'un
 * bouton "Acheter maintenant".
 *
 * Ici on ajoute la variante au panier en arriere-plan, puis on envoie
 * directement le client sur la page de paiement.
 */
(function () {
  if (window.__nestyBuyNowReady) return;
  window.__nestyBuyNowReady = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var button = target.closest('[data-buy-now]');
    if (!button) return;

    var form = button.closest('form');
    if (!form) return;

    // Le bouton est un type="button" : rien ne part tout seul, mais on coupe
    // court par securite si un theme le repasse un jour en submit.
    event.preventDefault();

    // Double-clic : on ne veut pas deux lignes dans le panier.
    if (button.getAttribute('aria-busy') === 'true') return;

    var originalLabel = button.textContent;
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    if (button.dataset.loadingText) button.textContent = button.dataset.loadingText;

    fetch(button.dataset.cartAddUrl + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart/add a repondu ' + response.status);
        window.location.href = button.dataset.checkoutUrl;
      })
      .catch(function () {
        // Repli : on rend la main au formulaire standard, qui affichera
        // l'erreur reelle (rupture de stock, quantite refusee...).
        button.removeAttribute('aria-busy');
        button.disabled = false;
        button.textContent = originalLabel;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
  });
})();
